import React, { Fragment, useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { Disclosure, Popover, Transition } from "@headlessui/react";

const PopOverBtn = ({ linksArray, menuTitle, mode }) => {
  const buttonRef = useRef(null);
  const [openState, setOpenState] = useState(false);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  let timeout;
  const timeoutDuration = 100;

  const toggleMenu = (open) => {
    setOpenState((openState) => !openState);
    buttonRef?.current?.click();
  };

  const onHover = (open, action) => {
    if (
      (!open && !openState && action === "onMouseEnter") ||
      (open && openState && action === "onMouseLeave")
    ) {
      clearTimeout(timeout);
      timeout = setTimeout(() => toggleMenu(open), timeoutDuration);
    }
  };

  const handleClick = (open) => {
    setOpenState(!open);
    clearTimeout(timeout);
  };

  const handleClickOutside = (event) => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      event.stopPropagation();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  // ✅ Mobile: Use Disclosure
  if (mode === "mobile") {
    return (
      <Disclosure>
        {({ open }) => (
          <div className="w-30">
            <Disclosure.Button className="flex justify-between w-30 border-b-2 border-black py-2 text-left">
              <span>{menuTitle}</span>
              <ChevronDownIcon
                className={`${open ? "rotate-180" : ""} w-5 h-5 transform transition-transform`}
              />
            </Disclosure.Button>

            <Disclosure.Panel className=" space-y-2">
              {linksArray.map(([title, href]) => (
                <a
                  key={title + href}
                  href={href}
                  className="block text-left py-2 hover:text-[#F4070C]"
                >
                  {title}
                </a>
              ))}
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
    );
  }

  // ✅ Desktop: Use Popover
  return (
    <Popover className="relative">
      {({ open }) => (
        <div
          onMouseEnter={() => onHover(open, "onMouseEnter")}
          onMouseLeave={() => onHover(open, "onMouseLeave")}
        >
          {/* Button */}
          <Popover.Button
            ref={buttonRef}
            className="outline-none hover:outline-none ring-0 ring-white"
          >
            <div
              className={classNames(
                open ? "text-[#F4070C]" : "",
                "flex justify-center"
              )}
              onClick={() => handleClick(open)}
            >
              <span className="py-8">
                {menuTitle}
                <ChevronDownIcon
                  className={classNames(
                    open ? "rotate-180" : "",
                    "w-6 h-6 inline-block text-black transform transition-all duration-500"
                  )}
                  aria-hidden="true"
                />
              </span>
            </div>
          </Popover.Button>

          {/* Panel */}
          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-40"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel
              static
              className="absolute left-0 z-50 w-72 mt-2 origin-top-right bg-white rounded-lg shadow-lg top-14 focus:outline-none"
            >
              <div
                className={classNames(
                  "grid space-y-[2px]",
                  "bg-[#FFCD72] border-x border-y border-black",
                  "rounded-md text-left"
                )}
              >
                {linksArray.map(([title, href]) => (
                  <Fragment key={title + href}>
                    <a
                      href={href}
                      className="px-3 py-2 hover:bg-green-900 hover:text-white whitespace-nowrap block w-full text-left"
                    >
                      {title}
                    </a>
                  </Fragment>
                ))}
              </div>
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  );
};

export default PopOverBtn;
